/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overlap_DetectionInputs */



/**
* | output |
* | --- |
* | "Overlap Detection" |
*
* @param {Overlap_DetectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const overlap_detection = /** @type {((inputs?: Overlap_DetectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overlap_DetectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détection des chevauchements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappungserkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento sovrapposizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение перекрытия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de superposición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重叠检测")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप डिटेक्शन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de sobreposição")
	return /** @type {LocalizedString} */ ("Overlap Detection")
});